import React from 'react';

import PropTypes from 'prop-types';

const VideoPauseIcon = ({ width = 29, height = 30, color = 'white' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29 30"
      fill="none"
    >
      <g filter="url(#filter0_d_19689_64589)">
        <path
          d="M22.5 6.5V21.5C22.5 21.8978 22.342 22.2794 22.0607 22.5607C21.7794 22.842 21.3978 23 21 23H17.25C16.8522 23 16.4706 22.842 16.1893 22.5607C15.908 22.2794 15.75 21.8978 15.75 21.5V6.5C15.75 6.10218 15.908 5.72064 16.1893 5.43934C16.4706 5.15804 16.8522 5 17.25 5H21C21.3978 5 21.7794 5.15804 22.0607 5.43934C22.342 5.72064 22.5 6.10218 22.5 6.5ZM11.25 5H7.5C7.10218 5 6.72064 5.15804 6.43934 5.43934C6.15804 5.72064 6 6.10218 6 6.5V21.5C6 21.8978 6.15804 22.2794 6.43934 22.5607C6.72064 22.842 7.10218 23 7.5 23H11.25C11.6478 23 12.0294 22.842 12.3107 22.5607C12.592 22.2794 12.75 21.8978 12.75 21.5V6.5C12.75 6.10218 12.592 5.72064 12.3107 5.43934C12.0294 5.15804 11.6478 5 11.25 5Z"
          fill={color}
          fillOpacity="0.9"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19689_64589"
          x="-7.75"
          y="-8"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19689_64589"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19689_64589"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

VideoPauseIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default VideoPauseIcon;
